The list of `Event.id` values to replay.
